import { Box, Typography } from '@mui/material';

const Footer = () => (
  <Box component='section'>
    <Typography sx={{ textAlign: 'center' }}>© 2022 - 2025 Albert Lay</Typography>
  </Box>
);

export default Footer;
